export default (function (node) {
  return {
    display: node.style.display
  };
});